import { getCurrentAppByHostname } from '../Helpers';

const quickSearchesStorage = `Smartforce.${
  getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
}.QuickSearches`;

export const addNewSearchText = (searchText: string): void => {
  const previousSearches: string[] = localStorage.getItem(quickSearchesStorage)
    ? JSON.parse(localStorage.getItem(quickSearchesStorage) || '[]')
    : [];

  const searchTextTrim: string = searchText ? searchText.trim() : '';
  const searchesUpdated =
    searchTextTrim !== '' && !previousSearches.includes(searchTextTrim)
      ? [searchTextTrim, ...previousSearches]
      : [...previousSearches];

  localStorage.setItem(
    quickSearchesStorage,
    JSON.stringify(searchesUpdated.slice(0, 5))
  );
};

export const getPreviousSearches = (): string[] => {
  return localStorage.getItem(quickSearchesStorage)
    ? JSON.parse(localStorage.getItem(quickSearchesStorage) || '[]')
    : [];
};
